// This file is AUTOGENERATED, do not edit it manually!!!

export const messageBoard = {
    add_message_button: 'Добавить сообщение',
    AdditionalRecipients: 'Дополнительные получатели',
    Ai_disabled_button: 'Начните печатать для активации меню ИИ',
    Append: 'Добавить',
    Apply: 'Применить',
    approval_request_approved_comment: 'одобрен с сообщением',
    approval_request_link: 'Запрос на согласование',
    approval_request_reject_comment: 'отклонен с сообщением',
    Approve: 'Согласовать',
    Approver_Approved: 'согласовано',
    Approver_HasNotSeen: 'не прочитано',
    Approver_NoAction: 'не согласовано',
    Approver_NotApproved: 'на рассмотрении',
    Approver_Rejected: 'отклонено',
    ApproversGroupTitle: 'Согласующие',
    Attachment_Delete: 'Файл \'{0}\' был удален.',
    BaseNotificationRule: 'На основании правила уведомлений',
    BeforePageUnloadMessage: 'Ваши изменения будут потеряны. Вы хотите покинуть эту страницу без сохранения изменений?',
    Cancel: 'Отмена',
    ChangeTone: 'Сменить интонацию',
    Close: 'Закрыть',
    ContactAdministrator: 'Свяжитесь с администратором',
    ContinueWriting: 'Продолжить текст с помощью ИИ',
    Delete: 'Удалить',
    DeleteAttachmentContentTemplate: 'Вы уверены, что хотите удалить файл \'{0}\' ?',
    DeleteAttachmentTitle: 'Удаление файла',
    Discard: 'Отмена',
    Download: 'Скачать',
    DropHere: 'Поместите файлы сюда',
    Edit: 'Редактировать',
    edit_actions: 'Нажмите ctrl + enter, чтобы <a apply>Применить</a> или esc для <a>Отмены</a>',
    email_only_mention_title: 'Пользователь будет уведомлен только по электронной почте',
    Error: 'Ошибка',
    FilePlural: '7#{0} Файл#{0} Файла#{0} Файлов',
    FileUploadError: 'Ошибка',
    FileVersion: 'Версия ',
    FileVersionShort: 'вер. ',
    Formal: 'Формальная',
    FreeSpaceTemplate: 'Вы использовали  {0} MB из {1} MB.',
    Friendly: 'Дружелюбная',
    GeneratedByAi: 'Написано с помощью ИИ...',
    HideFiles: 'Скрыть файлы',
    ImproveSpelling: 'Исправить правописание',
    ImproveWriting: 'Исправить стиль',
    mention_title: 'Упомянуть кого-либо',
    Message_Delete: 'Сообщение было удалено.',
    message_maxLength_description: 'Сообщение может содержать до 10 000 символов.',
    message_maxLength_title: 'Сообщение слишком длинное',
    MessageDeleteConfirmation: 'Удалить это сообщение?',
    messageEdited: '(изменено)',
    MessageEditedBy: 'Отредактировал(а) ',
    messagePlaceholderText: 'Добавьте сообщение, файл или @упоминание',
    MultipleApproversTemplate: '{0} из {1} {2}',
    MyComputer: 'Мой компьютер',
    NewMessageWatermark: 'Напишите сообщение или перетяните файлы...',
    NewPost: '7#{0} новое сообщение#{0} новых сообщения#{0} новых сообщений',
    No: 'Нет',
    NoMatchRecipients: 'Пользователь не найден',
    NoPermissionToEditMessage: 'К сожалению, у вас нет прав на редактирование этого сообщения.',
    Notification: 'Уведомление',
    Notify: 'Уведомить',
    NotifyLabel: 'Уведомить...',
    NotProjectMembers: 'Пользователи',
    OneDrive: 'OneDrive',
    OneDriveFilePicker: 'Проводник файлов OneDrive',
    Optimistic: 'Оптимистичная',
    Or: 'или',
    PluralApproved: '7#согласовал#согласовало#согласовало',
    PluralRejected: '7#{0} отклонил#{0} отклонило#{0} отклонило',
    Post: 'Отправить',
    PostWatingForApproval: 'Сообщение ожидает согласования',
    PreviewImages: 'Просмотр изображений',
    Professional: 'Профессиональная',
    ProjectMembers: 'Члены проекта',
    Reject: 'Отклонить',
    Replace: 'Заменить',
    RequestApprovalLabel: 'Согласовать с...',
    Retry: 'Заново',
    SharePoint: 'SharePoint',
    SharePointFilePicker: 'Проводник файлов SharePoint',
    ShowFiles: 'Показать файлы',
    ShowNext: 'Показать предыдущие',
    SingleApprovedTemplate: 'Согласовано с {0}',
    SingleApprovedTemplate_You: 'Согласовано с вами.',
    SingleApproverTemplate: 'На согласовании с {0}',
    SingleRejectedTemplate: 'Отклонено {0}',
    SingleRejectedTemplate_You: 'Отклонено вами.',
    Straightforward: 'Прямолинейная',
    Summarize: 'Резюмировать',
    SummarizeBulletPoints: 'Резюмировать в виде списка',
    TabFiles: 'Файлы',
    TabMessages: 'Сообщения',
    Teams: 'Команды',
    Undo: 'Отменить',
    UploadedBy: ' загрузил(а) ',
    Yes: 'Да',
    You: 'Вы',
};
